export const codeArr = [
    {
      code: `int result = 5 + 3 * 2;`
    },
    {
      code: `
  int x = 10;
  int y = 5;
  int z = x / (y - 2);
  `
    },
    {
      code: `
  int a = 5;
  int b = 10;
  int c = a++ * b--;
  `
    },
    {
      code: `
  int d = 0;
  int e = 10;
  int f = (d = 5, e += 2, d + e);
  `
    }
  ];
  